import api from '@resources/js/http/api'

export const sendStatsService = options => {
	api.post('/log/event/', options)
		.then(response => {
			if (!response.data.success) {
				const errorPhrase = 'Failed to send stats, check required options.'

				console.error(errorPhrase, options)

				shared.sendError(new Error(errorPhrase), options)
			}
		})
		.catch(error => console.error(error))
}
